import React, { useState } from "react";
import { Plus, Facebook, Linkedin, Instagram } from "lucide-react";


const campaignsData = [
  {
    id: 1,
    name: "Q4 Holiday Sale",
    status: "Active",
    platforms: ["facebook", "instagram"],
    spend: 1250,
    budget: 2000,
    clicks: 15430,
    conversions: 812,
  },
  {
    id: 2,
    name: "New Product Launch",
    status: "Active",
    platforms: ["linkedin"],
    spend: 800,
    budget: 1500,
    clicks: 45120,
    conversions: 312,
  },
  {
    id: 3,
    name: "Campaign Overview",
    status: "Active",
    platforms: ["linkedin"],
    spend: 1200,
    budget: 3000,
    clicks: 9120,
    conversions: 350,
  },
  {
    id: 4,
    name: "Q4 Campaign Overview",
    status: "Active",
    platforms: ["facebook", "instagram"],
    spend: 1800,
    budget: 5000,
    clicks: 9120,
    conversions: 812,
  },
  {
    id: 5,
    name: "Brand Awareness",
    status: "Active",
    platforms: ["facebook"],
    spend: 1500,
    budget: 2500,
    clicks: 43790,
    conversions: 180,
  },
  {
    id: 6,
    name: "Webinar Promotion",
    status: "Active",
    platforms: ["linkedin"],
    spend: 2700,
    budget: 4000,
    clicks: 640,
    conversions: 180,
  },
];

const Newfacebookcampaign = () => {
  const [platform, setPlatform] = useState("All");
  const [status, setStatus] = useState("All");
  const [dateRange, setDateRange] = useState("Last 30 Days");

  const filteredCampaigns = campaignsData.filter((c) => {
    const platformMatch =
      platform === "All" || c.platforms.includes(platform.toLowerCase());
    const statusMatch = status === "All" || c.status === status;
    return platformMatch && statusMatch;
  });

  return (
  <div>
      <div className="create-new-campaign-container">
      <div className="create-new-campaign-header">
        <div>
          <h2 className="create-new-campaign-title">Dashboard</h2>
          <p className="create-new-campaign-subtitle">
            Here’s an overview of your campaigns.
          </p>
        </div>
        <button className="create-new-campaign-btn">
          <Plus size={18} /> Create Campaign
        </button>
      </div>

      <div className="create-new-campaign-filters">
        <select
          className="create-new-campaign-dropdown"
          value={platform}
          onChange={(e) => setPlatform(e.target.value)}
        >
          <option value="All">Platform: All</option>
          <option value="facebook">Facebook</option>
          <option value="instagram">Instagram</option>
          <option value="linkedin">LinkedIn</option>
        </select>

        <select
          className="create-new-campaign-dropdown"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="All">Status: All</option>
          <option value="Active">Active</option>
          <option value="Paused">Paused</option>
          <option value="Completed">Completed</option>
        </select>

        <select
          className="create-new-campaign-dropdown"
          value={dateRange}
          onChange={(e) => setDateRange(e.target.value)}
        >
          <option>Last 7 Days</option>
          <option>Last 30 Days</option>
          <option>Last 3 Months</option>
        </select>
      </div>

      <div className="create-new-campaign-grid">
        {filteredCampaigns.map((c) => (
          <div key={c.id} className="create-new-campaign-card">
            <div className="create-new-campaign-card-header">
              <h4>{c.name}</h4>
              <div className="create-new-campaign-status-row">
                <span className="create-new-campaign-status active"></span>
                <span className="create-new-campaign-status-text">
                  {c.status}
                </span>
              </div>
            </div>

            <div className="create-new-campaign-platforms">
              {c.platforms.includes("facebook") && (
                <div className="create-new-campaign-icon-circle fb">
                  <Facebook size={14} />
                </div>
              )}
              {c.platforms.includes("linkedin") && (
                <div className="create-new-campaign-icon-circle li">
                  <Linkedin size={14} />
                </div>
              )}
              {c.platforms.includes("instagram") && (
                <div className="create-new-campaign-icon-circle ig">
                  <Instagram size={14} />
                </div>
              )}
            </div>

            <div className="create-new-campaign-info">
              <p>
                Spend: <strong>${c.spend.toLocaleString()}</strong> / $
                {c.budget.toLocaleString()}
              </p>
              <p>Conversions</p>
            </div>

            <div className="create-new-campaign-progress">
              <div
                className="create-new-campaign-progress-bar"
                style={{ width: `${(c.spend / c.budget) * 100}%` }}
              ></div>
            </div>

            <div className="create-new-campaign-footer">
              <span>Clicks: {c.clicks.toLocaleString()}</span>
              <span>{c.conversions} conversions</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
  );
};

export default Newfacebookcampaign;
